<template>
  <editor :id="id" default-tab="group" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import Group from './editor/Group'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Group",          name: "group",              component: Group},
      ]
    }
  }
}
</script>
